"use client";
import type { Agency } from "@-/prisma";
import type { AlgoliaAgencyDialogProps } from "@/components/AlgoliaDialog";
import type { ActiveAgencyMembership } from "@/types/active-membership";
import type { AgencyMemberActor } from "@/types/actor";
import { createContext } from "react";

export type { ActiveAgencyMembership };

export type AgencyLayoutContext = {
  actor: AgencyMemberActor;
  agency: Agency;
  activeAgencyMembership: ActiveAgencyMembership;
  openSearch: (
    props?: Pick<AlgoliaAgencyDialogProps, "tabs" | "onSelect">,
  ) => void;
  dismissSearch: () => void;
};

export default createContext<AgencyLayoutContext>(null!);
